import React, { useContext } from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { Dropdown } from '@comparethemarketau/manor-dropdown';

/**
 * & [role="button"] + div is using for replace the attribute width: 100% in StyledDropdownContent(manor-dropdown)
 */
const useStyles = createUseStyles((theme) => ({
    container: {
        '& div:first-child': {
            marginBottom: 0
        },
        '& [role="button"] + div': {
            width: 'max-content'
        }
    },
    dropdownButton: {
        lineHeight: theme.lineHeight.tight
    },
    dropdownLabel: {
        fontSize: theme.fontSize.xs,
        lineHeight: theme.lineHeight.tight,
        height: theme.spacing[16]
    },
    removeLabel: {
        '& label:first-of-type': {
            display: 'none'
        },
        '& :focus': {
            outline: 'unset'
        }
    }
}));

const withStyledManorDropdown = (ManorDropdown)  => (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className, ...rest } = props;

    return (
        <div data-testid="manor-dropdown"
            className={classNames('test-styledManorDropdown', classes.container, !props.label && classes.removeLabel)}>
            <ManorDropdown
                {...rest}
                className={classNames(classes.dropdownButton, className)}
                labelProps={{
                    variant: 'compact',
                    className: classes.dropdownLabel
                }}
            />
        </div>
    );
};

const StyledManorDropdown = withStyledManorDropdown(Dropdown);

export { StyledManorDropdown };
